import { Star } from "lucide-react";

/**
 * The three facts that reassure a first-time visitor, sitting right next to
 * the price where the decision is made: what other guests said, that booking
 * direct costs nothing extra, and how far out a change of plans is free.
 * The refund window matches CANCELLATION_POLICY_SUMMARY in property-facts.
 */
export function TrustLine({
  home,
  className = "",
}: {
  home: { rating?: number | string | null; review_count?: number | null };
  className?: string;
}) {
  const rating = home.rating ? Number(home.rating) : 0;
  const count = home.review_count ?? 0;
  return (
    <ul className={`flex flex-wrap items-center gap-x-3 gap-y-1 font-sans text-[12px] text-ink/70 ${className}`} data-testid="trust-line">
      {rating > 0 && count > 0 && (
        <li className="inline-flex items-center gap-1 text-ink">
          <Star className="h-3.5 w-3.5 fill-sun text-sun" aria-hidden="true" />
          <span className="font-medium">{rating.toFixed(2)}</span>
          <span className="text-ink/70">· {count} reviews</span>
        </li>
      )}
      <li>No platform fees</li>
      <li>Full refund up to 30 days before check-in</li>
    </ul>
  );
}
